import { ChildrenOnly } from "common/types";
import styled from "styled-components";
import { OrientationContextProvider } from "./OrientationContext";

export const OrientationContainer = ({ children }: ChildrenOnly) => {
  return (
    <OrientationContextProvider>
      <OrientationElement>
        <Contents>{children}</Contents>
      </OrientationElement>
    </OrientationContextProvider>
  );
};

const OrientationElement = styled.div`
  ${({ theme }) =>
    theme.deg === "90" || theme.deg === "180" || theme.deg === "270"
      ? `transform: rotate(${theme.deg}deg);`
      : ""}
`;

const Contents = styled.div`
  position: relative;
  ${({ theme }) => `
      ${theme.deg === "270" ? "left: calc(100vw - 100vh);" : ""}
      height: 100${theme.vh};
      width: 100${theme.vw};`}
`;
